import { cn } from '@/ui/utils';

export function UnreadIndicator({ className, ...props }: React.ComponentProps<'span'>) {
  return (
    <span
      data-has-children={props.children ? '' : undefined}
      className={cn(
        'data-has-children:size-3 size-2 -ml-0.5 inline-flex justify-center items-center text-white rounded-full shrink-0 bg-primary-10',
        className,
      )}
      {...props}
    />
  );
}
